/**
 * Created by mathias.gamperl on 18.12.2014.
 */
export default [
  "$q",
  "Events",
  "$window",
  "$injector",
  "$rootScope",
  "_",
  function ($q, Events, $window, $injector, $rootScope, _) {
    var errorPathToReloadName = "errorPathToLoad";

    function canAccessState(state) {
      return state.data && state.data.anonymousAccess;
    }

    function isCanceled(rejection) {
      var canceled =
        rejection.config &&
        rejection.config.timeout &&
        rejection.config.timeout.isGloballyCanceled;
      return canceled;
    }

    var requestInterceptor = {
      request: function (config) {
        var $state = $injector.get("$state");
        var $analytics = $injector.get("$analytics");

        var LocaleService = $injector.get("LocaleService");
        config.headers["dcb-frontend-url"] = $state.current.url;
        config.headers["dcb-frontend-state"] = $state.current.name;
        config.headers["dcb-frontend-language"] =
          LocaleService.getCurrentLocale();

        if (config.headers["dcb-frontend-action"] && $analytics) {
          $analytics.eventTrack(config.headers["dcb-frontend-action"], {
            category: "httpRequest",
          });
        }
        return config;
      },
      responseError: function (rejection) {
        var $state;
        var AuthenticationService;
        var MaintenanceService = $injector.get("MaintenanceService");
        var ConfigService = $injector.get("ConfigService");
        if (rejection.status === 401) {
          $state = $injector.get("$state");
          AuthenticationService = $injector.get("AuthenticationService");

          if (
            !canAccessState($state.current) &&
            $state.current.name &&
            $state.current.name !== "login"
          ) {
            if (ConfigService.isSessionStorageAvailable()) {
              if (!sessionStorage.getItem("afterLoginPath")) {
                sessionStorage.setItem("afterLoginPath", $state.current.name);
                sessionStorage.setItem(
                  "afterLoginParams",
                  JSON.stringify($state.params)
                );
              }
            }
            AuthenticationService.logoutWithoutRequest($state, "login");
            return $q.reject(rejection);
          }
        }

        if (rejection.status === 503) {
          //$state = $injector.get('$state');
          //AuthenticationService = $injector.get("AuthenticationService");

          //AuthenticationService.logoutWithoutRequest($state, "", "offline");

          //MaintenanceService.showDialog(false);
          MaintenanceService.showRequestError();
          rejection.data = [];
          return rejection;
        }

        if (rejection.status === 0 && !isCanceled(rejection)) {
          $state = $injector.get("$state");
          AuthenticationService = $injector.get("AuthenticationService");
          AuthenticationService.logoutWithoutRequest($state, "", "offline");
          //MaintenanceService.showRequestError();
          return $q.reject(rejection);
        }

        if (rejection.status === -1 && !isCanceled(rejection)) {
          //MaintenanceService.showDialog(false);
          MaintenanceService.showRequestError();
          rejection.data = [];
          return rejection;
        }

        return $q.reject(rejection);
      },
      response: function (response) {
        var MaintenanceService = $injector.get("MaintenanceService");

        if (response.config.maintenanceSwitch) {
          MaintenanceService.setCheckMaintenanceFlag(true);
        }

        if (response.config.method === "GET") {
          $rootScope.$emit(Events.RELOAD_DASHBOARD_LAZY);
        }

        //prevents Restangular Bug when null value in response.data []
        if (response.data) {
          if (_.isArray(response.data)) {
            // response.data = response.data.filter(v => v !== null);
          }
        }

        return response;
      },
    };

    return requestInterceptor;
  },
];



// WEBPACK FOOTER //
// ./src/ui/app/interceptors/httpInterceptor.js